import { gql } from '@apollo/client';

export const CONTROL_PRODUCT_CODE = gql`
  query ControlProductCode(
    $productSlug: String!
    $codeToControl: String!
    $context: RequestContext!
  ) {
    controlCode(productSlug: $productSlug, codeToControl: $codeToControl, context: $context) {
      productCode
      status
    }
  }
`;
